// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".navbar-center.active[data-v-edb431c6]{max-width:60%!important}.navbar-center.active[data-v-edb431c6]:before{display:block;content:\"\";position:fixed;top:0;left:0;right:0;bottom:0;z-index:20;background:rgba(0,0,0,.5)}.navbar-center.active .app-header-menu[data-v-edb431c6]{opacity:0!important}.navbar-center.active .search-form-wrapper[data-v-edb431c6]{width:100%;padding-left:50px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
